<template lang="pug">
  model-form(
        :editable="false"
        switchEdit
        ref="form"
        reset-text="limpiar"
        submit-text="Editar"
        title="Editar producto"
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from './fields'
/* vuex */
import {mapActions} from 'vuex'
/* model */
import ItemModel from '@/models/Warehouse/WhItem'
/* services */
import Translator from '@/services/translator'
import BranchOfficeService from '@/services/api/branchOffice'

export default {
  name: 'comercial-information',
  props: {
    dataProduct:{
      type: Object,
      required: true,
    },
    product:{
      type: Object,
    },
    updateComponent:{
      type: Boolean,
      default: false,
    },
  },
  data: function(){
    return {
      formData: {},
      formFields: FieldsCreate,
      loadedProduct: false,
    }
  },
  // computed: {},
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    submit() {
      this.$refs.form.setWait(true).then(this.update)
    },
    /*
     */
    update(data) {  
      let model = new ItemModel({id:data.id})
      model.sync(this.formatData(data))
      .then(r=>this.successUpdate(r))
      //.then(this.redirectTo(data))
      .catch(this.error)
      .then(this.$refs.form.setWait)
      
    },
    formatData(data){
      let branchOld  = [...data.branch_offices]
    
    let branchCurrent = [...data.branch_office_selected]
    let branchWithStock = branchCurrent.map(br=>{
      let oldBranch = branchOld.find(bOld=>bOld.g_branch_office_id === br.id)
      br.critical_stock = oldBranch.critical_stock
      br.minimum_stock = oldBranch.minimum_stock
      br.maximum_stock = oldBranch.maximum_stock
      br.g_branch_office_id = br.id
      return br
    })

      data.branch_office_data = branchWithStock
      data.tags = data.wh_tags.map(t=>(typeof t ==='object') ? t.id : t)
      //hard code data
      data.is_inventoriable = data.wh_item.is_inventoriable
      data.is_repackaged = data.is_repackaged
      data.is_seasonal = data.is_seasonal
      data.uom_quantity = data.wh_item.uom_quantity 
      data.wh_unit_of_measurement_id = data.wh_item.wh_unit_of_measurement_id || 4
      data.have_decimal_quantity = data.wh_item.have_decimal_quantity
      return data
    },
    
    /*
     */
    successUpdate(info) {
      this.$emit('comercialInfo',info)
      this.$emit('productEdited')
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información comercial creada exitosamente',
          timeout: 3000,
      })
      this.$refs.form.edit=false
    },
    error(error) {
    
      this.setSnackbar({
          type: 'error',
          title: 'Error',
          message: Translator(ItemModel, error.response.data),
          timeout: 15000,
      })
    },
    resetForm() {
        this.formData = {}
        this.formFields[0].props.items = []
    },
    setFormData: async function(model) {
      model.branch_office_selected = await this.setStocksBranchOffice(model)
      this.formData = model.reset()
    },
    async setStocksBranchOffice(model) {
      console.log(model,'product ------>here')
      let branch = await BranchOfficeService.fetchAll()
      
      let aux = branch.map(b=>{
        let auxBranch = model.branch_offices.find(branch => branch.g_branch_office_id === b.id )
        b.cost_price = Number(auxBranch.cost_price)
        b.gains_margin = Number(auxBranch.gains_margin)
        return b
      })

      console.log(aux)

      return aux.map(b=>{
        let auxBranch = model.sale_prices.find(branch=> branch.branch_office_id === b.id)
        b.sale_price = auxBranch.sale_price
        return b
      })
    },
    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
  },
  watch: {
    dataProduct(val){
      if(val && this.loadedProduct===false){
        this.setFormData(this.dataProduct)
        this.loadedProduct = true
      }
    },
    updateComponent(val){
      if(val){
        this.loadedProduct = false
      }
    }
  },
  components: {
    'model-form' : ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>